import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserBadge from "../../assets/images/svg-icons-material-io/badge_FILL0_wght400_GRAD0_opsz48.svg";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import { Tag } from "primereact/tag";
import TwoFactorIcon from "../../assets/images/2fa.png";

const DetailsUser = ({
  userDetails,
  CloseDetailUser,
  updateUser,
  customerOrgVal,
}) => {
  const navigate = useNavigate();
  const {
    isUserLogedIn,
    sharedObject,
    userRole,
    userToken,
    SetSharedObject,
    setSearchObj,
  } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
    sharedObject: state.sharedObject,
    setSearchObj: state.setSearchObj,
  }));
  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }
  const [detailUser, setDetailUser] = useState({}); //
  const [detailUserAdmin, setDetailUserAdmin] = useState(false);
  const [usrContact, setUsrContact] = useState({});
  const [userOrg, setUeserOrg] = useState([]);
  const [orgDetail, setOrgDetial] = useState({});
  const [userEmails, setUserEmails] = useState([]);
  const [userStatus, setUserStatus] = useState({});
  const [userAssignsharedEmails, setAssignSharedEmails] = useState([]);
  const [userAssignUserEmails, setAssignUserEmails] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [msg, SetMsg] = useState("");
  const [msgSuccess, SetMsgSuccess] = useState(false);
  const [usersCreate, SetUsersCreate] = useState(false);
  const [twoFactor, SetTwoFactor] = useState(false);
  const [orgName, setOrgName] = useState("");
  const [customerObj, setCustomerObj] = useState("");
  const [directTrust, setDirectTrust] = useState(false);
  const [IDProofing, SetIDProofing] = useState(false);
  const [orgTrustedAgent, SetOrgTrustedAgent] = useState(false);
  const [orgAdmin, SetOrgAdmin] = useState(false);
  const [flag, setFlag] = useState(false);
  const [userObj, setUserObj] = useState(false);
  const [userOrgVal, setUserOrgVal] = useState([]);
  const [CustomerTwoFactor, SetCustomerTwoFactor] = useState(false);
  const [notExists, SetNotExists] = useState(true);

  useEffect(() => {
    SetNotExists(true);
    SetCustomerTwoFactor(userDetails.orgTFA);
    console.log(userDetails);
    setUserObj(userDetails);
    let userOrg = customerOrgVal ? customerOrgVal : "";
    let userDet = userDetails ? userDetails.userDet : "";
    let userDetOrg = userDetails ? userDetails.userOrg : "";
    let userDetAdmin = userDetOrg[0]?.isRoleEditable && userDetOrg[0]?.isAdmin;
    let userContact = userDetails ? userDetails.userContact : "";
    let userEmails = userDetails ? userDetails.userEmails : "";
    let userStatus = userDetails ? userDetails.userContact : "";

    setOrgName(userOrg.split(",")[1]);
    setUserOrgVal(userOrg);
    setDetailUser(userDet);
    setDetailUserAdmin(userDetAdmin);
    setUsrContact(userContact);
    SetUsersCreate(userContact?.createUsers);
    SetTwoFactor(userContact.twoFactorEnabled);
    setUeserOrg(userDetOrg);
    setUserEmails(userEmails);
    setUserStatus(userStatus);

    getCustomerDetails(userContact.vendorId);
    const usrTemp = [];
    const sharedTemp = [];
    if (userDetails && userDetails.userEmails.length > 0) {
      userDetails.userEmails.map((el) => {
        if (el.userEmailTypeString === "Shared") {
          sharedTemp.push(el);
        } else {
          usrTemp.push(el);
        }
      });
    }
    setAssignSharedEmails(sharedTemp);
    setAssignUserEmails(usrTemp);
    var customer = sharedObject.vendorsObj.find((element) => {
      return element.id === parseInt(userDetails?.userContact?.vendorId);
    });
    SetSharedObject("TwoFactorObject", {});
    setCustomerObj(customer);
  }, [userDetails]);
  useEffect(() => {
    if (flag) navigate(flag, { replace: true });
  }, [flag, navigate]);
  const AdminToggle = async (org) => {
    setDetailUserAdmin(org.isAdmin);
    SetMsg("");
    SetErrCreateMsg(false);
    SetMsgSuccess(false);
    SetIDProofing(org.vendorRequiresIDProofing);
    // SetOrgTrustedAgent(org.vendorAllowsTrustedAgent);
    // SetOrgAdmin(org.isAdmin);
    setOrgDetial(org);
    let m = `Please confirm you want to remove ${detailUser?.name} as an administrator from ${org.organizationName} organization.`;
    SetMsg(m);

    $("#AssignAdminModal").modal("show");
  };

  const AssignUnassign = async () => {
    SetErrCreateMsg(false);
    let call = "";

    if (detailUserAdmin) {
      call =
        "/users/RemoveAsAdmin?userId=" +
        usrContact.id +
        "&orgId=" +
        orgDetail.organizationId;
    } else {
      call =
        "/users/AssignAsAdmin?userId=" +
        usrContact.id +
        "&orgId=" +
        orgDetail.organizationId +
        "&allowCreateUsers=" +
        orgAdmin +
        "&makeTrustedAgent=" +
        orgTrustedAgent +
        "&issueInvites=" +
        IDProofing +
        "&requireIdVerification=" +
        orgDetail.vendorRequiresIDProofing;
    }

    setProcessing(true);
    SetMsgSuccess(false);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetMsgSuccess(true);
      updateUser({ ...usrContact, orgId: userDetails.orgId });
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetMsg(str);
      SetErrCreateMsg(true);
      setProcessing(false);
    }
    setProcessing(false);
  };
  const [collapse, SetCollapse] = useState(false);
  const [IDsValue, SetIDsValue] = useState("");
  const [secondValue, SetSecondValue] = useState("");
  const [thirdValue, SetThirdValue] = useState("");
  const [addIdFlag, SetIdFlag] = useState(false);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [answers, setAnswers] = useState(null);
  const setAnswer = async (questionId, answer, chck) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };

  const DeleteId = async (el) => {
    setProcessing(true);
    let call =
      "/users/DeleteUserId?userId=" +
      usrContact.id +
      "&recordId=" +
      el.recordId;
    const res = await CallAPI(call, null, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      updateUser({ ...usrContact, orgId: userDetails.orgId });
      setProcessing(false);
    } else if (res.status === "SERVERERROR") {
      setProcessing(false);
    }
  };
  const RemoveSharedEmail = async (el) => {
    setProcessing(true);
    let call =
      "/emails/RemoveSharedEmail?directEmailId=" +
      el.id +
      "&userId=" +
      el.userId;
    const res = await CallAPI(call, null, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      updateUser({ ...usrContact, orgId: userDetails.orgId });
      setProcessing(false);
    } else if (res.status === "SERVERERROR") {
      setProcessing(false);
    }
  };
  function isNumeric(n) {
    return (!isNaN(parseFloat(n)) && isFinite(n)) || n === "" || n === ".";
  }
  const [errMsg, SetErrMsg] = useState(null);
  const ToggleCreateUser = (val) => {
    SetErrCreateMsg(false);
    SetMsgSuccess(false);
    SetMsg(null);
    SetErrMsg(null);
    $("#RemoveCreateUserModal").modal("show");
  };
  const ConfirmToggleCreateUser = async () => {
    SetErrCreateMsg(false);
    SetMsg(null);
    SetErrMsg(null);
    if (usersCreate === true) {
      let call =
        "/users/RemovePermission?userId=" +
        usrContact.id +
        "&permissionName=Create Users";
      setProcessing(true);
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        $("#RemoveCreateUserModal").modal("hide");
        updateUser({ ...usrContact, orgId: userDetails.orgId });
      } else if (res.status === "SERVERERROR") {
        let msg = res.data;
        let str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetErrMsg(str);
        SetErrCreateMsg(true);
        setProcessing(false);
        SetUsersCreate(true);
      }
    } else {
      var call =
        "/users/AssignAsAdmin?userId=" +
        usrContact.id +
        "&orgId=" +
        userDetails.orgId +
        "&allowCreateUsers=" +
        true +
        "&makeTrustedAgent=" +
        orgTrustedAgent +
        "&issueInvites=" +
        IDProofing +
        "&requireIdVerification=" +
        IDProofing;
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        $("#RemoveCreateUserModal").modal("hide");
        SetMsgSuccess(true);
        updateUser({ ...usrContact, orgId: userDetails.orgId });
        SetUsersCreate(true);
      } else if (res.status === "SERVERERROR") {
        let msg = res.data;
        let str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
      }
    }
    setProcessing(false);
  };
  const toggleTwoFactor = (val) => {
    //SetTwoFactor(val);
    SetErrCreateMsg(false);
    $("#TwoFactorModal").modal("show");
  };
  const ConfirmToogleTwoFactor = async () => {
    SetErrCreateMsg(false);
    let displayMsg = "";
    if (detailUser.twoFactorEnabled) {
      displayMsg = `Two-Factor Authentication has been successfully turned off for ${detailUser.name}.`;
    } else {
      displayMsg = `Two-Factor Authentication has been successfully turned on for ${detailUser.name}.`;
    }
    let call =
      "/users/UpdateTFASettings?userId=" +
      usrContact.id +
      "&tfaPhone=" +
      usrContact.tfaPhone +
      "&tfaEmail=" +
      usrContact.tfaEmail +
      "&tfaOn=" +
      usrContact.tfaOn;
    setProcessing(true);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetMsg(displayMsg);
      updateUser({ ...usrContact, orgId: userDetails.orgId });
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrMsg(str);
      SetErrCreateMsg(true);
      setProcessing(false);
    }
    setProcessing(false);
  };
  const getSeverity = (product) => {
    switch (product) {
      case "Active":
        return "success";
      case "Pending":
        return "warning";
      case "IDP Failed and Locked":
        return "danger";
      case "Failed":
        return "danger";
      case "Locked":
        return "danger";
      default:
        return null;
    }
  };
  const TwoFactorSignUp = async () => {
    $("#TwoFactorSignupModal").modal("show");
  };

  const getCustomerDetails = async (vendorId) => {
    var obj = sharedObject.vendorsObj;
    for (var i = 0; i < obj.length; i++) {
      var c = obj[i];
      if (c.id === vendorId) {
        setDirectTrust(c.directTrust);
      }
    }
  };
  const SearchNpi = async (valId) => {
    setProcessing(true);
    SetNotExists(true);
    let flag = false;
    let call = "/organization/SearchNPI?searchNPI=" + valId + "&npiType=1";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      if (dt && Object.keys(dt).length > 0 && dt.constructor === Object) {
        SetNotExists(true);
        flag = true;
      } else {
        SetNotExists(false);
        flag = false;
      }
    } else if (res.status === "SERVERERROR") {
      SetNotExists(false);
      setProcessing(false);
      flag = false;
    }
    setProcessing(false);
    return await flag;
  };
  const AddId = async () => {
    SetIdFlag(true);
    SetErrCreateMsg(false);
    if (IDsValue === "NPI") {
      let npiFlag = await SearchNpi(secondValue);
      if (!npiFlag) return;
    }
    let IdType = IDsValue === "NPI" ? 0 : IDsValue === "State" ? 1 : 2;
    let obj = {
      RecordId: 0,
      IDType: IdType,
      Value: IDsValue === "State" ? thirdValue : secondValue,
      IssuingAuthority: IDsValue === "State" ? secondValue : thirdValue,
    };
    setProcessing(true);
    let call = "/users/addUserId?userId=" + usrContact.id;
    const res = await CallAPI(call, obj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    console.log(res);
    if (res.status === "SUCCESS") {
      SetIDsValue("");
      SetSecondValue("");
      SetThirdValue("");
      SetIdFlag(false);
      updateUser({ ...usrContact, orgId: userDetails.orgId });
      setProcessing(false);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrMsg(str);
      SetErrCreateMsg(true);
      setProcessing(false);
    }
  };
  return (
    <div className="DetailsUser">
      <div
        className="modal fade "
        id="detailsUserModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="DetailsDirectorySearch"
        aria-hidden="false"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <div
                className="modal-title spacer-inline text-size3"
                id="myModalLabel"
              >
                {" "}
                Details{" "}
              </div>
              <button
                type="button"
                className="close"
                aria-label="Close"
                data-dismiss="modal"
                onClick={CloseDetailUser}
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="details-header blk-clr">
                    <img
                      className="spacer-margin7"
                      src={UserBadge}
                      alt="Medical Information Icon"
                    />
                    <div className="text-size6 ft-wt blk-clr">
                      {detailUser?.name}
                    </div>
                    <div className="blk-clr">
                      Status:{" "}
                      <Tag
                        value={userStatus?.status}
                        className="text-size1-1 text-lt"
                        severity={getSeverity(userStatus?.status)}
                      ></Tag>
                    </div>
                    <div className="sp-margin1">
                      <i className="bi bi-pencil-square sp-margin5"></i>
                      <a
                        href="javascript:void(0);"
                        onClick={(el) => {
                          $("#editUserModal").modal("show");
                        }}
                      >
                        EDIT
                      </a>
                    </div>
                  </div>

                  <section className="field-wrapper">
                    <div>
                      <label for="UserName">Username:</label>
                      <span> {detailUser?.userNameDisplay} </span>
                      <br />
                      <label for="addresses">Address:</label>
                      <span className="sp-margin5 spacer-inline">
                        {usrContact.addresses && usrContact.addresses.length > 0
                          ? usrContact.addresses[0].firstLine
                          : ""}
                      </span>
                      <span className="sp-margin5 spacer-inline">
                        {usrContact.addresses && usrContact.addresses.length > 0
                          ? usrContact.addresses[0].secondLine
                          : ""}
                        ,
                      </span>
                      <span className="sp-margin5 spacer-inline">
                        {usrContact.addresses && usrContact.addresses.length > 0
                          ? usrContact.addresses[0].city
                          : ""}
                        ,
                      </span>
                      <span className="sp-margin5 spacer-inline">
                        {usrContact.addresses && usrContact.addresses.length > 0
                          ? usrContact.addresses[0].state
                          : ""}
                      </span>
                      {/*<span className="sp-margin5">*/}
                      {/*    {usrContact.addresses && usrContact.addresses.length > 0*/}
                      {/*    ? usrContact.addresses[0].country*/}
                      {/*        : ""}*/}
                      {/*</span>*/}
                      <span className="sp-margin5 spacer-inline">
                        {usrContact.addresses && usrContact.addresses.length > 0
                          ? usrContact.addresses[0].postalCode
                          : ""}
                      </span>
                    </div>
                    <div>
                      <label for="phone">Phone:</label>
                      {usrContact.addresses && usrContact.addresses.length > 0
                        ? formatPhoneNumber(
                            usrContact.addresses[0].phone.substring(0, 10)
                          )
                        : ""}
                      <span className="spacer-margin2">
                        <label for="ext">Ext:</label>
                        <span className="sp-margin5">
                          {usrContact.addresses &&
                          usrContact.addresses.length > 0
                            ? usrContact.addresses[0]?.phone.substring(
                                10,
                                usrContact.addresses[0].phone.length
                              )
                            : ""}
                        </span>
                      </span>
                    </div>
                    <div>
                      <label for="fax">Fax:</label>
                      {usrContact.addresses && usrContact.addresses.length > 0
                        ? usrContact.addresses[0].fax
                          ? formatPhoneNumber(
                              usrContact.addresses[0].fax.substring(0, 10)
                            )
                          : ""
                        : ""}
                      <span className="spacer-margin2">
                        <label for="ext">Ext:</label>
                        <span className="sp-margin5">
                          {usrContact.addresses &&
                          usrContact.addresses.length > 0
                            ? usrContact.addresses[0].fax
                              ? usrContact.addresses[0]?.fax.substring(
                                  10,
                                  usrContact.addresses[0].fax.length
                                )
                              : ""
                            : ""}
                        </span>
                      </span>
                    </div>
                    <div>
                      <label for="Email">Email:</label>
                      <span className="word-set1">
                        {usrContact?.contactEmail}
                      </span>
                    </div>
                    <div className="d-emails-container">
                      <label for="UserName">Direct Emails:</label>
                      <span>
                        {/*{!userAssignUserEmails.length > 0 ? 0 : null}*/}

                        {userAssignUserEmails.length >= 0 ? (
                          <a
                            href="javascript:void(0);"
                            underline="none"
                            className="font-weight-bold"
                            onClick={(el) => {
                              let splitObj = userOrgVal.split(",");
                              let obj = {
                                // Email: usrContact.contactEmail,
                                Domain: usrContact?.domainName,
                                // OrganizationId:
                                //   splitObj.length === 0 ? null : splitObj[0],
                                // OrgName:
                                //   splitObj.length === 0 ? null : splitObj[1],
                                UserName: detailUser?.userName,
                                Name: detailUser?.name,
                                Flag: "detailUser",
                                Navigate: "detailUser",
                                Id: usrContact.id,
                                LastName: detailUser.lastName,
                                FirstName: detailUser.firstName,
                              };
                              SetSharedObject("UserIdEmail", obj);
                              $(".modal").modal("hide");
                              setFlag("/emails");
                            }}
                          >
                            {userAssignUserEmails.length}
                          </a>
                        ) : null}
                      </span>
                    </div>
                  </section>
                  <hr />
                  {/*User Info*/}
                  <section className="field-wrapper">
                    <div>
                      <Link
                        onClick={() => {
                          let ob = {
                            id: userObj?.orgId,
                            OrganizationName: userObj?.oName,
                            ShowParent: "ShowParent",
                          };
                          setSearchObj(ob);
                          $("#detailsUserModal").modal("hide");
                          setFlag("/organizations");
                        }}
                        title="Organization Link"
                      >
                        <label for="Organization">Organization:</label>
                        <span>{userObj?.oName}</span>
                      </Link>
                      <br />
                      <label for="Domain">Domain:</label>
                      <span>{usrContact?.domainName}</span>
                      <br />
                      <label for="LastLogin">Last Login:</label>
                      <span>
                        {usrContact?.lastLoginTime
                          ? new Date(usrContact?.lastLoginTime).toLocaleString()
                          : ""}
                      </span>
                      <br />
                      <label for="DateCreated">Date Created:</label>
                      <span>
                        {new Date(usrContact?.dateCreated).toLocaleString()}
                      </span>
                      <br />
                      <label>Require ID Proofing:</label>
                      <span>
                        {usrContact?.requireIdVerification &&
                        customerObj?.idProofingRequired
                          ? "YES"
                          : "NO"}
                      </span>
                      <br />
                      <label for="Domain">DirectTrust:</label>
                      <span>{directTrust ? "YES" : "NO"}</span>
                      <br />
                      <label>Trusted Agent:</label>
                      <span>
                        {usrContact?.trustedAgent &&
                        customerObj?.trustedAgentAgreement
                          ? "YES"
                          : "NO"}
                      </span>
                      <br />
                      <label for="Specialty">Specialty</label>
                    </div>
                    <div className="sub-catg">
                      <label for=" SpecialtyType">Type:</label>
                      <span>
                        {usrContact.specialties &&
                        usrContact.specialties.length > 0
                          ? usrContact.specialties[0].type
                          : ""}
                      </span>
                      <br />
                      <label for="Classification">Classification:</label>
                      <span>
                        {usrContact.specialties &&
                        usrContact.specialties.length > 0
                          ? usrContact.specialties[0].classification
                          : ""}
                      </span>
                      <br />
                      <label for=" Specialization">Specialization:</label>
                      <span>
                        {usrContact.specialties &&
                        usrContact.specialties.length > 0
                          ? usrContact.specialties[0].specialization
                          : ""}
                      </span>
                    </div>
                  </section>

                  <div className="label-divider">
                    <div className="sp-margin7 spacer-inline">Organization</div>
                  </div>
                  <div className="field-wrapper o-flow">
                    <table>
                      <tr>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Admin</th>
                      </tr>
                      {userOrg.length > 0
                        ? userOrg?.map((el) => {
                            return (
                              <tr key={el.organizationId}>
                                <td>{el.organizationName}</td>
                                <td className="w-sm"> {el.roleName}</td>
                                <td className="w-sm">
                                  <input
                                    type="checkbox"
                                    checked={el.isAdmin}
                                    onClick={(e) => {
                                      AdminToggle(el);
                                    }}
                                  />
                                </td>
                              </tr>
                            );
                          })
                        : null}
                    </table>
                  </div>
                  <div className="label-divider">
                    <div className="sp-margin7 spacer-inline">
                      Assigned Organization Emails
                    </div>
                  </div>

                  <div className="field-wrapper o-flow">
                    <table>
                      <tr>
                        <th>Email</th>
                        <th>Purpose</th>
                        <th>Action</th>
                      </tr>
                      {userAssignsharedEmails.length > 0
                        ? userAssignsharedEmails?.map((el) => {
                            return (
                              <tr key={el.id}>
                                <td className="word-set">
                                  {el.directEmailAddress}
                                </td>
                                <td className="w-sm">
                                  {el.emailPurposeTypeString}
                                </td>
                                <td className="w-sm">
                                  <a
                                    href="javascript:void(0);"
                                    underline="none"
                                    className="font-weight-bold"
                                    onClick={(e) => RemoveSharedEmail(el)}
                                  >
                                    Unassign
                                  </a>
                                </td>
                              </tr>
                            );
                          })
                        : null}
                    </table>
                    {userAssignsharedEmails?.length === 0 ? (
                      <div className="sub-catg">
                        There are no emails assigned to this user.
                      </div>
                    ) : null}
                  </div>

                  {/*Permissions - For Admins Only*/}
                  <div className="field-wrapper label-divider">
                    <div className="sp-margin7 spacer-inline">Permission</div>
                  </div>
                  <div className="field-wrapper">
                    <div>
                      <label>Two-Factor Authentication</label>
                      {CustomerTwoFactor === true ? (
                        <div className="spacer-inline">
                          {usrContact?.twoFactorEnabled ? (
                            <a
                              href="javascript:void(0);"
                              className={
                                !usrContact.twoFactorEnabled ? "gray" : ""
                              }
                              onClick={(el) => {
                                const tm = Date.now();
                                var obj = { ...usrContact, TimeStamp: tm };
                                SetSharedObject("TwoFactorObject", obj);
                                $("#TwoFactorSettingModal").modal("show");
                              }}
                            >
                              <i className="bi bi-gear-fill "></i>
                            </a>
                          ) : (
                            <a href="javascript:void(0);" className={"gray"}>
                              <i className="bi bi-gear-fill "></i>
                            </a>
                          )}
                        </div>
                      ) : (
                        <a
                          href=" javascript:void(0);"
                          className="btn btn-outline-info"
                          onClick={TwoFactorSignUp}
                        >
                          {" "}
                          Learn More{" "}
                        </a>
                      )}
                    </div>
                    <div>
                      <label className="spacer-margin8">Administrator:</label>
                      <input
                        className="form-control spacer-margin5"
                        type="checkbox"
                        name="Administrator"
                        id="Administrator"
                        onChange={(el) => {
                          let o = {
                            vendorRequiresIDProofing:
                              userOrg[0].vendorRequiresIDProofing,
                            vendorAllowsTrustedAgent:
                              userOrg[0].vendorAllowsTrustedAgent,
                            isAdmin: userOrg[0].isAdmin,
                            organizationName: userOrg[0].organizationName,
                            isRoleEditable: userOrg[0].isRoleEditable,
                            organizationId: userOrg[0].organizationId,
                          };
                          AdminToggle(o);
                        }}
                        value={detailUserAdmin}
                        checked={detailUserAdmin}
                        disabled={
                          usrContact.status === "Pending" && !userOrg[0].isAdmin
                            ? true
                            : false
                        }
                      />
                    </div>
                    {detailUserAdmin ? (
                      <div>
                        <label className="spacer-margin8">Create Users: </label>
                        <input
                          type="checkbox"
                          className="spacer-margin5"
                          checked={usersCreate}
                          value={usersCreate}
                          onChange={(el) => ToggleCreateUser(el.target.checked)}
                          disabled={!detailUserAdmin}
                        />
                      </div>
                    ) : (
                      <div>
                        <label className="spacer-margin8">Create Users: </label>
                        <span>{usrContact?.usersCreate ? "YES" : "NO"}</span>
                      </div>
                    )}
                  </div>

                  {/*ID Info*/}
                  <div className="label-divider">
                    <div className="sp-margin7 spacer-inline">ID</div>
                    <div className="v-set2 spacer-inline float-r">
                      <a
                        href="javascript:void(0);"
                        className="btn btn-info min-wsm"
                        onClick={(el) => {
                          SetCollapse(!collapse);
                        }}
                        role="button"
                        aria-controls="ID-form"
                      >
                        <i
                          className={`bi ${!collapse ? "bi-plus" : "bi-dash"}`}
                        ></i>
                      </a>
                    </div>
                  </div>
                  <div
                    id="ID-form"
                    className={`field-wrapper ${!collapse ? "collapse" : null}`}
                  >
                    <select
                      className="form-control w-md2 sp-margin13 spacer-inline sp-margin5"
                      onChange={(el) => {
                        SetIDsValue(el.target.value);
                        SetSecondValue("");
                        SetNotExists(true);
                        if (el.target.value === "NPI") {
                          SetThirdValue("CMS");
                        } else {
                          SetThirdValue("");
                        }
                      }}
                    >
                      <option value={""}>Select</option>
                      <option value={"NPI"}>NPI</option>
                      <option value={"State"}>State License</option>
                      <option value={"Other"}>Other</option>
                    </select>
                    {IDsValue === "State" ? (
                      <>
                        <select
                          className="form-control w-md2 sp-margin13 spacer-inline"
                          value={secondValue}
                          onChange={(el) => SetSecondValue(el.target.value)}
                        >
                          <option value={""}>Issuing State</option>
                          {stateCodeArray.map((el) => (
                            <option key={el} value={el}>
                              {el}
                            </option>
                          ))}
                        </select>
                        <input
                          className="form-control sp-margin13"
                          type="text"
                          placeholder="Enter Value"
                          value={thirdValue}
                          onChange={(el) => SetThirdValue(el.target.value)}
                        />
                      </>
                    ) : IDsValue === "" ? null : (
                      <>
                        <input
                          className="form-control w-md2 sp-margin13 spacer-inline"
                          maxLength={IDsValue === "NPI" ? 10 : 16}
                          value={secondValue}
                          onChange={(el) => {
                            let vl = el.target.value;
                            let chk = isNumeric(vl);
                            if (chk && IDsValue === "NPI") {
                              SetSecondValue(el.target.value);
                            } else if (IDsValue === "Other") {
                              SetSecondValue(el.target.value);
                            }
                          }}
                          type={IDsValue === "NPI" ? "tel" : "text"}
                          placeholder={
                            IDsValue === "NPI"
                              ? "10 digit number"
                              : "Enter Value"
                          }
                        />
                        <input
                          className="form-control sp-margin13"
                          type="text"
                          disabled={IDsValue === "NPI"}
                          value={thirdValue}
                          onChange={(el) => SetThirdValue(el.target.value)}
                          placeholder={
                            IDsValue === "NPI"
                              ? "CMS"
                              : " Enter Issuing Authority"
                          }
                        />
                      </>
                    )}

                    {addIdFlag &&
                    IDsValue === "NPI" &&
                    secondValue.length < 10 ? (
                      <div className="alert alert-danger">
                        NPI must have 10 numbers.
                      </div>
                    ) : null}
                    {!notExists ? (
                      <div className="alert alert-danger">
                        We could not connect or find NPI {secondValue} you
                        entered. Please double check your number and try again.
                      </div>
                    ) : null}
                    {addIdFlag &&
                    ((IDsValue === "State" && thirdValue === "") ||
                      (IDsValue === "Other" && secondValue === "")) ? (
                      <div className="alert alert-danger">
                        ID value is required.
                      </div>
                    ) : null}
                    {errCreateMsg ? (
                      <div
                        className={`alert alert-danger`}
                        dangerouslySetInnerHTML={{ __html: errMsg }}
                      />
                    ) : null}
                    <button
                      className="btn btn-success sp-margin13"
                      type="button"
                      onClick={(e) => AddId()}
                      disabled={
                        IDsValue === ""
                          ? true
                          : IDsValue === "NPI" && secondValue.length < 10
                          ? true
                          : IDsValue === "State" &&
                            (secondValue === "" || thirdValue === "")
                          ? true
                          : IDsValue === "Other" && secondValue === ""
                          ? true
                          : false
                      }
                    >
                      Add
                    </button>
                  </div>

                  <table className="o-flow">
                    <tr>
                      <th className="w-sm">Type</th>
                      <th>Value</th>
                      <th>Issuing Authority</th>
                      <th className="ctr">Remove</th>
                    </tr>
                    {usrContact?.iDs?.map((el) => (
                      <tr key={el.recordId}>
                        <td>{el.idTypeString}</td>
                        <td>{el.value}</td>
                        <td>{el.issuingAuthority}</td>
                        <td
                          className="ctr click-box"
                          onClick={(e) => DeleteId(el)}
                        >
                          <i className="bi bi-x-circle rd-clr"></i>
                        </td>
                      </tr>
                    ))}
                  </table>
                  {usrContact?.iDs?.length === 0 ? (
                    <div className="sub-catg">
                      There are no IDs created for this user.
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  data-dismiss="modal"
                  onClick={CloseDetailUser}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
          {processing ? <div className="loading"></div> : null}
        </div>
      </div>

      <div
        className="modal fade"
        id="AssignAdminModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="Assign Admin Privileges Modal"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title" id="myModalLabel">
                {detailUserAdmin
                  ? "Unassign Administrator"
                  : "Assign Administrator"}
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="false">&times;</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              {msgSuccess ? (
                <div className="ctr sp-pad4">
                  Member has been updated successfully.
                </div>
              ) : !detailUserAdmin ? (
                <>
                  <div className="descript-container">
                    Assign {detailUser?.name} as an administrator to
                    {orgDetail?.organizationName} with the following privileges:
                  </div>
                  <div className="field-wrapper modal-content-form">
                    {customerObj?.idProofingRequired ? (
                      <div>
                        <input
                          type="checkbox"
                          className="spacer-margin5"
                          checked={IDProofing}
                          value={IDProofing}
                          onClick={(e) => SetIDProofing(e.target.checked)}
                        />
                        <label className="spacer-margin8">
                          Require ID Proofing
                        </label>
                      </div>
                    ) : null}
                    {userRole === "SES ADMINISTRATOR" &&
                    customerObj?.trustedAgentAgreement ? (
                      <div>
                        <input
                          type="checkbox"
                          className="spacer-margin5"
                          checked={orgTrustedAgent}
                          value={orgTrustedAgent}
                          onClick={(e) => SetOrgTrustedAgent(e.target.checked)}
                        />
                        <label className="spacer-margin8">Trusted Agent</label>
                      </div>
                    ) : null}
                    <div>
                      <input
                        type="checkbox"
                        className="spacer-margin5"
                        checked={orgAdmin}
                        value={orgAdmin}
                        onClick={(e) => SetOrgAdmin(e.target.checked)}
                      />
                      <label className="spacer-margin8">Create Users</label>
                    </div>
                  </div>
                </>
              ) : (
                <div className="ctr sp-pad4">
                  {`Please confirm you want to remove ${detailUser?.userNameDisplay} as an administrator from ${orgDetail.organizationName} organization.`}
                </div>
              )}
              {errCreateMsg ? (
                <div
                  className={`alert alert-danger`}
                  dangerouslySetInnerHTML={{ __html: msg }}
                />
              ) : null}
            </div>
            <div className="modal-footer">
              {msgSuccess ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => {
                    AssignUnassign();
                  }}
                >
                  Confirm
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                {msgSuccess ? "Close" : "Cancel"}
              </button>
            </div>
          </div>
          {processing ? <div className="loading"></div> : null}
        </div>
      </div>
      {/* Confirmation Modal for User Role Permissions*/}
      <div
        className="modal fade"
        id="UserRoleConfirmModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="User Role Confirmation Modal"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title" id="myModalLabel">
                Confirmation
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {usersCreate ? (
                <div className={`ctr sp-pad4`}>
                  {`Please confirm you want to unassign ${detailUser?.userNameDisplay} as an administrator.`}
                </div>
              ) : (
                <div className={`ctr sp-pad4`}>
                  {`Please confirm you want to assign ${detailUser?.userNameDisplay} as an administrator.`}
                </div>
              )}
              {errCreateMsg ? (
                <div
                  className={`alert alert-danger`}
                  dangerouslySetInnerHTML={{ __html: errMsg }}
                />
              ) : null}
            </div>
            <div className="modal-footer">
              {msgSuccess ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => {
                    ConfirmToggleCreateUser();
                  }}
                >
                  Confirm
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                {" "}
                Cancel{" "}
              </button>
            </div>
          </div>
          {processing ? <div className="loading"></div> : null}
        </div>
      </div>

      {/* Confirmation Modal for Create User Modal */}
      <div
        className="modal fade"
        id="RemoveCreateUserModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="Remove Create User Modal"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title" id="myModalLabel">
                Confirmation
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {usersCreate ? (
                <div className={`ctr sp-pad4`}>
                  {`Please confirm you want to remove permission to create new users for ${detailUser?.userNameDisplay}.`}
                </div>
              ) : (
                <div className={`ctr sp-pad4`}>
                  {`Please confirm you want ${detailUser?.userNameDisplay} to create new users.`}
                </div>
              )}
              {errCreateMsg ? (
                <div
                  className={`alert alert-danger`}
                  dangerouslySetInnerHTML={{ __html: errMsg }}
                />
              ) : null}
            </div>
            <div className="modal-footer">
              {msgSuccess ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => {
                    ConfirmToggleCreateUser();
                  }}
                >
                  Confirm
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                {" "}
                Cancel{" "}
              </button>
            </div>
          </div>
          {processing ? <div className="loading"></div> : null}
        </div>
      </div>

      {/* Two Factor Settings Modal */}
      <div
        className="modal fade"
        id="TwoFactorModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="Assign Admin Privileges Modal"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title" id="myModalLabel">
                {" "}
                Confirmation{" "}
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="false">&times;</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              {usrContact.twoFactorEnabled ? (
                <div className={`ctr sp-pad4`}>
                  {`Do you want to turn off Two-Factor Authentication for ${detailUser?.userNameDisplay}?`}
                </div>
              ) : (
                <div className={`ctr sp-pad4`}>
                  {`Do you want to turn on Two-Factor Authentication for ${detailUser?.userNameDisplay}?`}
                </div>
              )}
              {errCreateMsg ? (
                <div
                  className={`alert alert-danger`}
                  dangerouslySetInnerHTML={{ __html: errMsg }}
                />
              ) : null}
            </div>
            <div className="modal-footer">
              {msgSuccess ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => {
                    ConfirmToogleTwoFactor();
                  }}
                >
                  Confirm
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                {" "}
                Cancel{" "}
              </button>
            </div>
          </div>
          {processing ? <div className="loading"></div> : null}
        </div>
      </div>

      {/* Two Factor Signup Modal */}
      <div
        className="modal fade"
        id="TwoFactorSignupModal"
        data-backdrop="false"
        data-keyboard="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="Sign Up Info"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title" id="myModalLabel">
                {" "}
                Two-Factor Authentication{" "}
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="false">&times;</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <div className="ctr title-2">
                <img
                  src={TwoFactorIcon}
                  alt="Two Factor Authentication Badge"
                  title="Two Factor Authentication"
                />
                <div className="sp-margin4">
                  {" "}
                  Sign Up for Two-Factor Authentication{" "}
                </div>
              </div>
              <div className="modal-content-body descript-p">
                <div className="sp-margin3 text-reg">
                  <p>
                    Two-factor Authentication enhances the security of your
                    users by providing additional authentication code to protect
                    their account.
                  </p>
                  Setting up Two-Factor Authentication for your organization
                  will provide the capability to enable any users in your
                  organization with this added security. Contact your account
                  manager to find out how to sign up.
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                {" "}
                Close{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
      {processing ? <div className="loading"></div> : null}
    </div>
  );
};

export default DetailsUser;
